module.exports = __webpack_public_path__ + "static/media/18-5.5e80a6fc.mp3";